import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { tagPlatform } from "@/lib/platform";
tagPlatform();
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Workspace from "@/pages/Workspace";
import Marketplace from "@/pages/Marketplace";
import GroupDetail from "@/pages/GroupDetail";
import SellerStorefront from "@/pages/SellerStorefront";
import Suggestions from "@/pages/Suggestions";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import TrashPage from "@/pages/Trash";
import WalletPage from "@/pages/Wallet";
import AdminPanel from "@/pages/AdminPanel";
import DeleteAccount from "@/pages/DeleteAccount";
import InstallPrompt from "@/components/InstallPrompt";
import NativeAuthBridge from "@/components/NativeAuthBridge";
import WallpaperSync from "@/components/WallpaperSync";
import OfflineBar from "@/components/OfflineBar";
import OfflineGate from "@/components/OfflineGate";
import ReminderNotifications from "@/components/ReminderNotifications";

function AppRouter() {
  const location = useLocation();
  // Synchronous OAuth fragment detection — handle before any route renders
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<OfflineGate feature="Signing in"><Login /></OfflineGate>} />
      <Route path="/reset-password" element={<OfflineGate feature="Resetting your password"><ResetPassword /></OfflineGate>} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/app" element={<Workspace />} />
      <Route path="/market" element={<OfflineGate feature="The Marketplace"><Marketplace /></OfflineGate>} />
      <Route path="/seller/:sellerId" element={<OfflineGate feature="Seller shops"><SellerStorefront /></OfflineGate>} />
      <Route path="/suggestions" element={<OfflineGate feature="Suggestions"><Suggestions /></OfflineGate>} />
      <Route path="/trash" element={<TrashPage />} />
      <Route path="/groups" element={<Navigate to="/market?community=groups" replace />} />
      <Route path="/groups/:groupId" element={<OfflineGate feature="Groups"><GroupDetail /></OfflineGate>} />
      <Route path="/wallet" element={<OfflineGate feature="Your wallet"><WalletPage /></OfflineGate>} />
      <Route path="/admin" element={<OfflineGate feature="The admin panel"><AdminPanel /></OfflineGate>} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/delete-account" element={<OfflineGate feature="Deleting your account"><DeleteAccount /></OfflineGate>} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NativeAuthBridge />
        <WallpaperSync />
        <ReminderNotifications />
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" />
        <OfflineBar />
        <InstallPrompt />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
